import Vue from "vue";
import Router from "vue-router";

import store from "./store";

import Login from "./views/Auth/Login/Login.vue";
import LoginVerify from "./views/Auth/Login/LoginVerify.vue";

import Register from "./views/Auth/Register/Register.vue";
import RegisterVerify from "./views/Auth/Register/RegisterVerify.vue";
import RegisterProfile from "./views/Auth/Register/RegisterProfile.vue";

import Request from "./views/Auth/PasswordReset/Request.vue";
import Verify from "./views/Auth/PasswordReset/Verify.vue";
import Reset from "./views/Auth/PasswordReset/Reset.vue";

import Dashboard from "./views/Dashboard";

import Settings from "./views/Configuration/Settings";
import Analysis from "./views/Configuration/Analysis";
import Upload from "./views/Configuration/Upload";
import Ruleset from "./views/Configuration/Ruleset";
import Report from "./views/Configuration/Report";

import ManageGroup from "./views/Configuration/ManageGroup";

import Browse from "./views/Enumeration/Browse";
import Notification from "./views/Enumeration/Notification";
import NotificationAll from "./views/NotificationAll";
import Search from "./views/Enumeration/Search";

import IdMsettings from "./views/Identity/IdMsettings";

import Contact from "./views/Contact";

import InviteAccept from "./views/Auth/InviteAccept";

//import HomePage from "./views/Home/HomePage.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      name: "login",
      path: "/login",
      component: Login,
      meta: {
        requiresVisitor: true
      }
    },
    {
      name: "login-verify",
      path: "/login-verify",
      component: LoginVerify,
      meta: {
        requiresVisitor: true
      }
    },
    {
      name: "register",
      path: "/register",
      component: Register,
      meta: {
        requiresVisitor: true
      }
    },
    {
      name: "register-verify",
      path: "/register-verify",
      component: RegisterVerify,
      meta: {
        requiresVisitor: true
      }
    },
    {
      name: "register-profile",
      path: "/register-profile",
      component: RegisterProfile,
      meta: {
        requiresVisitor: true
      }
    },
    {
      name: "password-reset-request",
      path: "/password-reset-request",
      component: Request,
      meta: {
        requiresVisitor: true
      }
    },
    {
      name: "password-reset-verify",
      path: "/password-reset-verify",
      component: Verify,
      meta: {
        requiresVisitor: true
      }
    },
    {
      name: "password-reset-new",
      path: "/password-reset-new",
      component: Reset,
      meta: {
        requiresVisitor: true
      }
    },
    {
      name: "invite-accept",
      path: "/invite/accept",
      component: InviteAccept,
      meta: {
        requiresVisitor: true,
        requiresAuth: true
      },
      props: true
    },
    {
      name: "home",
      path: "/",
      component: Dashboard,
      meta: {
        requiresVisitor: true,
        requiresAuth: true
      },
      props: true
    },
    {
      name: "dashboard",
      path: "/dashboard",
      component: Dashboard,
      meta: {
        requiresVisitor: true,
        requiresAuth: true
      },
      props: true
    },
    {
      name: "settings",
      path: "/configuration/settings",
      component: Settings,
      meta: {
        requiresVisitor: true,
        requiresAuth: true
      },
      props: true
    },
    {
      name: "analysis",
      path: "/configuration/analysis",
      component: Analysis,
      meta: {
        requiresVisitor: true,
        requiresAuth: true
      },
      props: true
    },
    {
      name: "report",
      path: "/configuration/analysis/:id/report",
      component: Report,
      meta: {
        requiresVisitor: true,
        requiresAuth: true
      },
      props: true
    },
    {
      name: "upload",
      path: "/configuration/upload",
      component: Upload,
      meta: {
        requiresVisitor: true,
        requiresAuth: true
      },
      props: true
    },
    {
      name: "ruleset",
      path: "/configuration/ruleset",
      component: Ruleset,
      meta: {
        requiresVisitor: true,
        requiresAuth: true
      },
      props: true
    },
    {
      name: "browse",
      path: "/enumeration/browse",
      component: Browse,
      meta: {
        requiresVisitor: true,
        requiresAuth: true
      },
      params: {
        showmap: false,
        showtable: true
      },
      props: true
    },
    {
      name: "search",
      path: "/enumeration/search",
      component: Search,
      meta: {
        requiresVisitor: true,
        requiresAuth: true
      },
      props: true
    },
    {
      name: "notifications",
      path: "/enumeration/notifications",
      component: Notification,
      meta: {
        requiresVisitor: true,
        requiresAuth: true
      },
      props: true
    },
    {
      name: "notificationsall",
      path: "/notifications",
      component: NotificationAll,
      meta: {
        requiresVisitor: true,
        requiresAuth: true
      },
      props: true
    },
    {
      name: "idmsettings",
      path: "/idmsettings",
      component: IdMsettings,
      meta: {
        requiresVisitor: true,
        requiresAuth: true
      },
      props: true
    },
    {
      path: "/managegroup",
      component: ManageGroup,
      meta: {
        requiresVisitor: true,
        requiresAuth: true
      }
    },
    {
      path: "/contact",
      component: Contact,
      meta: {
        requiresVisitor: true,
        requiresAuth: true
      }
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.state.auth.login_verified) {
      next({
        path: "/login"
      });
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.requiresVisitor)) {
    if (store.state.auth.login_verified) {
      next({
        path: "/dashboard"
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
